"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Panels = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var Panels = function (props) {
    var children = props.children, className = props.className;
    return react_1.default.createElement("div", { className: (0, classnames_1.default)('man-ui panels', className) }, children);
};
exports.Panels = Panels;
exports.default = exports.Panels;
